<template>
  <img
    :class="classes"
    v-lazy="mapUrl"/>
</template>

<script>
export default {
  props: {
    lat: {
      required: true,
      type: Number,
    },
    lng: {
      required: true,
      type: Number,
    },
    classes: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      width: 300,
      height: 200,
      scale: 2,
      zoom: 15,
    };
  },
  computed: {
    apiKey() {
      return process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
    },
    staticUrl() {
      return process.env.VUE_APP_GOOGLE_MAPS_STATIC_URL;
    },
    mapUrl() {
      const markers = `markers=color:red|${this.lat},${this.lng}`;
      const options = `size=${this.width}x${this.height}&scale=${this.scale}&zoom=${this.zoom}`;

      return `${this.staticUrl}?key=${this.apiKey}&${markers}&${options}`;
    },
  },
};
</script>
